import { EhrResourceDiffJobRequest, EhrWritePath } from "@metriport/shared-internal";
import { getOssProxyOrFail } from "../api";

export async function getMetriportPatientId(patientId: string): Promise<string> {
  const apiOssProxy = getOssProxyOrFail();
  const resp = await apiOssProxy.get(`/patient/${patientId}`);
  if (!resp.data) throw new Error(`Patient ID not returned @ PracticeFusion`);
  return resp.data;
}

export async function getTermsOfServiceAccepted(): Promise<{
  isTermsOfServiceAccepted: boolean;
}> {
  const apiOssProxy = getOssProxyOrFail();
  const resp = await apiOssProxy.get(`/practice/terms-of-service`);
  return resp.data;
}

export async function acceptTermsOfService(): Promise<void> {
  const apiOssProxy = getOssProxyOrFail();
  await apiOssProxy.post(`/practice/terms-of-service`);
}

export async function writeResourceToChart({
  patientId,
  resource,
  path,
}: {
  patientId: string;
  resource: object;
  path: EhrWritePath;
}): Promise<void> {
  const apiOssProxy = getOssProxyOrFail();
  await apiOssProxy.post(`/chart/${patientId}/${path}`, resource);
}

export async function getResourceDiffJob(
  patientId: string,
  jobId?: string
): Promise<EhrResourceDiffJobRequest | undefined> {
  const apiOssProxy = getOssProxyOrFail();
  const resp = await apiOssProxy.get(
    `/patient/${patientId}/resource/diff/${jobId ?? "latest"}?direction=metriport-only`
  );
  if (jobId && !resp.data) {
    throw new Error(`Resource diff job not returned for jobId @ PracticeFusion`);
  }
  return resp.data;
}

export async function startResourceDiffJob(patientId: string): Promise<string> {
  const apiOssProxy = getOssProxyOrFail();
  const resp = await apiOssProxy.post(
    `/patient/${patientId}/resource/diff?direction=metriport-only`
  );
  if (!resp.data) throw new Error(`Resource diff job ID not returned @ PracticeFusion`);
  return resp.data;
}
